export default (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PORTAL_PAGE':
      return { ...state, [action.payload.page.id]: action.payload }
    default:
      return state
  }
}
